<script lang="ts" setup>
import { useDialog, useAuth } from "#imports";
import MPButton from "../forms/MPButton.vue";
import MPImg from "../widgets/MPImg.vue";
import MPAuth from "./MPAuth/MPAuth.vue";

const { openDialog } = useDialog();
const authStore = useAuth();
</script>

<template>
  <div class="join-message">
    <div class="join-message-graphic">
      <ul>
        <li>
          <i class="ri-user-community-line" />
          <p>
            <span>Support creators</span> and
            <span>local experts</span> discovering authentic new spots.
          </p>
        </li>
        <li>
          <i class="ri-earth-line" />
          <p>
            Go <span>beyond ratings and lists:</span> Discover stories, places,
            and people behind every corner.
          </p>
        </li>
        <li>
          <i class="ri-door-open-line" />
          <p>
            A <span>community of curious minds;</span> Open the door to
            incredible <span>real-world locations.</span>
          </p>
        </li>
      </ul>
    </div>
    <div class="join-message-content">
      <h4>Join Mappr <span>for free</span></h4>
      <p>Explore the world through honest recommendations.</p>
      <MPButton
        version="secondary"
        label="Google"
        hideLabel
        @click="authStore.signInWithOAuth('google')"
      >
        <MPImg src="/images/google-social-auth-icon.svg" />
        Sign up with Google
      </MPButton>
      <hr />
      <span class="or">or</span>
      <MPButton
        label="Continue with email"
        icon="ri-mail-line"
        @click="openDialog(MPAuth, { startOn: 'signup' }, { blockClose: true })"
      />
      <ul>
        <li>
          <i class="ri-user-community-line" />
          <p>
            <span>Support creators</span> and
            <span>local experts</span> discovering authentic new spots.
          </p>
        </li>
        <li>
          <i class="ri-earth-line" />
          <p>
            Go <span>beyond ratings and lists:</span> Discover stories, places,
            and people behind every corner.
          </p>
        </li>
        <li>
          <i class="ri-door-open-line" />
          <p>
            A <span>community of curious minds;</span> Open the door to
            incredible <span>real-world locations.</span>
          </p>
        </li>
      </ul>
      <small>
        You can access our Privacy Policy. Your data will be processed through
        this form solely to manage the queries you submit.
      </small>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
@import "@/assets/css/breakpoints.pcss";
.join-message {
  z-index: 9000;
  height: fit-content;
  display: flex;
  justify-content: center;
}

.join-message-graphic {
  width: 25rem;
  display: none;
  @mixin screen md {
    display: block;
    background-image: url("/images/join-background.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  ul {
    display: none;
    @mixin screen md {
      display: block;
      margin: 18rem 2rem 2.25rem;
      padding: 0;
      list-style: none;
    }
  }
}

.join-message-content {
  padding: 2.5rem 1rem 1.5rem;
  border-radius: 0;
  background-color: white;
  width: fit-content;
  max-width: 22rem;
  display: flex;
  flex-direction: column;
  @mixin screen md {
    padding: 2.5rem 2rem 1.5rem;
    box-shadow: var(--shadow-xl);
  }
}

.join-message-content:deep(img) {
  width: 16px;
  margin-right: 6px;
}

.join-message-content:deep(button) {
  padding: 0.5rem;
  font-size: 0.975rem;
}

.social-auth {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  &:deep(img) {
    width: 12px;
    margin-right: 4px;
  }
  &:deep(button) {
    padding: 0.5rem;
    font-size: 0.975rem;
  }
}

small {
  margin-top: auto;
  font-size: 0.725rem;
  font-style: normal;
  font-weight: 400;
  color: var(--color-slate-500);
}

hr {
  margin: 1.25rem 0 0.5rem;
  border: 0;
  border-top: 1px solid var(--color-slate-100);
}

.or {
  position: relative;
  top: -1.15rem;
  align-text: center;
  background-color: white;
  color: var(--color-slate-300);
  font-size: 0.875rem;
  padding: 0 0.5rem;
  margin: 0 auto;
}

h4 {
  font-weight: 700;
  margin: 0.5rem 0 0.25rem;
  span {
    color: var(--color-rose-400);
  }
}

p {
  margin: 0.5rem 0 2rem;
  line-height: 1.25 !important;
  color: var(--color-slate-400);
}

ul {
  margin: 1rem 0;
  padding: 0;
  list-style: none;
  @mixin screen md {
    display: none;
  }
}

li {
  display: flex;
  align-items: top;
  padding-bottom: auto;
  color: var(--color-slate-900);
  h5 {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 700;
    margin-bottom: 0.25rem;
  }
  i {
    margin-right: 0.25rem;
    margin-top: 0.35rem;
  }
  p {
    margin: 0.5rem 0;
    line-height: 1.4 !important;
    color: var(--color-slate-500);
  }
  span {
    color: var(--color-rose-400);
  }
}
</style>
